module.exports = __webpack_public_path__ + "s/img/Chill_D_1.5bae62bf.jpg";